<template>
	<div class="user-info">
		<el-dropdown @command="handleCommand">
			<span class="el-dropdown-link">
				{{companyName}}<i class="el-icon-arrow-down el-icon--right"></i>
			</span>
			<el-dropdown-menu slot="dropdown">
				<el-dropdown-item command="a"> 退 出 </el-dropdown-item>
			</el-dropdown-menu>
		</el-dropdown>
	</div>
</template>

<script>
	import Cookies from 'js-cookie';
	export default {
		name: "userinfo",
		props: [],
		data() {
			return {
				companyName: '',
			};
		},
		mounted() {
			this.companyName = Cookies.get('companyName');
		},
		methods: {
			// 下拉菜单触发事件
			handleCommand(command) {
				if (command == 'a') {
					this.$confirm('请注意保存数据，确定要退出登录吗?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						Cookies.remove('Authorization');
						Cookies.remove('companyName');
						// 跳转到登录页
						this.$router.push({
							path: '/login',
						});
					}).catch(() => {
						
					});
				}
			}
		},
	};
</script>

<style scoped lang="scss">
	.user-info {
		.el-dropdown-link{
			cursor: pointer;
		}
	}
</style>